import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-128">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-2xl shadow-xl border border-brand-creamDark p-4 pr-10 max-w-sm flex items-start gap-4" data-id="element-129">
          <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 text-brand-gray hover:text-brand-text" data-id="element-130">
            <X className="w-4 h-4" data-id="element-131" />
          </button>

          <div className="text-3xl shrink-0 mt-1" data-id="element-132">🎵</div>

          <div data-id="element-133">
            <p className="font-bold text-brand-text text-sm mb-0.5" data-id="element-134">
              Carlos M. Córdoba 🇦🇷
            </p>
            <p className="text-brand-red font-bold text-xs mb-1" data-id="element-135">
              Compró MÚSICA LISTA
            </p>
            <p className="text-brand-gray text-[10px] flex items-center gap-1" data-id="element-136">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" data-id="element-137"></span>
              Compra verificada &middot; hace 12 min
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}